import type { Direction } from "../direction";
import type { PointsToDirection } from "../interfaces";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { MetalBlock } from "./metalBlock";

export class MetalBlockDiagonal extends MetalBlock implements PointsToDirection {
	static key = "MetalBlockDiagonal";
	private direction: Direction;

	constructor(xy: XY, direction: Direction) {
		super(xy);
		this.direction = direction;
	}

	getDirection(): Direction {
		return this.direction;
	}

	setDirection(dir: Direction): void {
		this.direction = dir;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), direction: this.direction };
	}

	static deserialize(data: any): MetalBlockDiagonal {
		const m = new MetalBlockDiagonal(deserializeXY(data.xy), data.direction);
		m.visualId = data.visualId;
		return m;
	}
}
